import { 
    yellow,
    red,
    blue,
    axisName,
    pageBg
} from './color'

export var topToBottom = function(a='20160531'){
  return {
    $axisIndex: [0, 1],
    $seriesIndex: 0,
    // 标线样式
    lineStyle: {
      normal: {
        lineDash: [4, 2],
        lineWidth: 1
      }
    },
    
    data: [
    { 
      lineStyle: {
        normal: {
          stroke:blue
        }
      },
      points: [
      {
        xValue: a,
        y: 'top'
      },
      {
        xValue: a,
        y: 'bottom'
      }
      ]
    }
   
    ]
  }
}
export var leftToRight = function(a=180, b=200){
  return {
    $axisIndex: [0, 1],
    $seriesIndex: 0,
    // 标线样式
    lineStyle: {
      normal: {
        lineDash: [4, 2],
        lineWidth: 1
      }
    },
    
    data: [
    { 
      lineStyle: {
        normal: {
          stroke:blue
        }
      },
      points: [
      {
        x: 'left',
        yValue: a
      },
      {
        x: 'right',
        yValue: a
      }
      ]
    },
    {
      lineStyle: {
        normal: {
          stroke:red
        }
      },
      points: [
      {
        x: 'left',
        yValue: b
      },
      {
        x: 'right',
        yValue: b
      }
      ]
    }
    ]
  }
}
